import React from 'react';
import { Button } from '../../../components/ui';
import { useGenerateTemplateReport } from '../../../mutation/template';
import { useGetTemplateReportStatus } from '../../../query/template';

export default function GenerateReportButton() {
  const { mutate: generateReport, isLoading } = useGenerateTemplateReport();
  const {
    data,
    isLoading: templateReportLoading,
  } = useGetTemplateReportStatus();
  const isGenerating = data?.status === 'generating';
  return (
    <Button
      disabled={isLoading || templateReportLoading || isGenerating}
      isLoading={isLoading || templateReportLoading}
      onClick={generateReport}
    >
      {isGenerating ? 'A report is being generated ...' : 'Generate new report'}
    </Button>
  );
}
